import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { collegeErrorPageMessage, commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonService } from 'src/app/services/common/common.service';
import Swal from 'sweetalert2';
import { DuplicateQuestionDialogBoxComponent } from '../duplicate-question-dialog-box/duplicate-question-dialog-box.component';

@Component({
  selector: 'app-upload-question-dialog-box',
  templateUrl: './upload-question-dialog-box.component.html',
  styleUrls: ['./upload-question-dialog-box.component.scss']
})
export class UploadQuestionDialogBoxComponent implements OnInit {
  DropdownForm: FormGroup = this.formBuilder.group({});
  commonConstant: any = [];
  commonErrorMessage: any = [];
  FileUpload!: File;
  errorMessage: any = [];
  submitted: boolean = false;
  showData: boolean = false;

  constructor(public modalService: NgbActiveModal,
    private common: CommonService,
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private modal: NgbModal
  ) { this.common.isSystemAlert = true; }
  @ViewChild('fileUploadModal') fileUploadModal;

  ngOnInit(): void {
    this.onInitDropdownForm();
    this.commonConstant = CommonConstant;
    this.commonErrorMessage = commonErrorMessage;
    this.errorMessage = collegeErrorPageMessage;
  }
  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }
  onInitDropdownForm() {
    this.DropdownForm = this.formBuilder.group({
      File: ['', [Validators.required]],
      CollegeId: ['', [Validators.required]],
      CollegeBatchId: ['', [Validators.required]],
    });
  }



  get dropDownFormControl() {
    return this.DropdownForm.controls;
  }


  onFileChanged(event: any) {
    let file: any;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      var extn = event.target.files[0].name.substr(
        event.target.files[0].name.lastIndexOf('.') + 1
      );
      if (extn != event.target.files[0].name) {
        var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
        switch (ext.toLowerCase()) {
          case 'xls':
          case 'xlsx':
          case 'csv':
            break;
          default:
            (<HTMLInputElement>document.getElementById('File')).value = '';
            this.DropdownForm.reset();
            this.toastr.error("Please select xls,xlsx and csv files")
            return true;
        }
      } else {
        (<HTMLInputElement>document.getElementById('File')).value = '';
        this.DropdownForm.reset();
        return true;
      }
      reader.onload = function (e) {
        file = e.target;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.FileUpload = event.target.files[0];
    } else {
    }
    return null;
  }


  Upload() {
    this.submitted = true;
    this.spinner.show();
    let form = new FormData();
    form.append('ExcelQuestionAnswerFile', this.FileUpload);
    const apiUrl = this.apiUrl.apiUrl.question.UploadQuestion;
    this.CommonService.doPost(apiUrl, form).pipe().subscribe({
      next: async (response) => {
        this.modalService.close('save');
        this.spinner.hide();
        if (response.success) {
          if (response.data.duplicates.length > 0) {
            const modalRef = this.modal.open(DuplicateQuestionDialogBoxComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'full-width-model' });
            modalRef.componentInstance.data = response.data;
            modalRef.result.then((result) => {

            }).catch((error) => {
            });
          }
          else {
            Swal.fire({
              icon: 'success',
              text: response.data.newRecordsInserted + " Question(s) uploaded successfully.",
              allowOutsideClick: false,
              buttonsStyling: false,
              customClass: {
                confirmButton: 'sweet-alert-button'
              }
            }).then(() => {
              this.spinner.hide();
            })
            this.spinner.hide();
            this.submitted = false;
            this.showData = true;
          }

        }
        else {
          Swal.fire({
            icon: 'error',
            text: response.message,
            allowOutsideClick: false,
            buttonsStyling: false,
            customClass: {
              confirmButton: 'sweet-alert-button'
            }
          })
          this.spinner.hide();
          this.fileUploadModal.nativeElement.click();
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.fileUploadModal.nativeElement.click();
      }
    });
  }

}
